import axios from "axios";

import { BUBA_API_URL, BUBA_API_URL_V2, getEnvironmentVariable } from "../utils/environment";
import { addStatusCodeInterceptorToInstance } from "../utils/loggers";

export const getBubaClient = (v2 = false) => {
  const bubaClient = axios.create({
    baseURL: getEnvironmentVariable(v2 ? BUBA_API_URL_V2 : BUBA_API_URL),
    headers: { "Content-Type": "application/vnd.api+json" }
  });

  addStatusCodeInterceptorToInstance(bubaClient);

  return bubaClient;
};

export const bubaClient = getBubaClient();
export const bubaClientV2 = getBubaClient(true);
